import type { FC, SVGProps } from 'react';
import React from 'react';

type IconProps = SVGProps<SVGSVGElement>;

export const CheckmarkIcon: FC<IconProps> = props => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9403 5.99994C12.2332 5.70705 12.708 5.70705 13.0009 5.99994C13.2938 6.29284 13.2938 6.76771 13.0009 7.0606L7.50092 12.5606L5.00092 10.0606C4.70803 9.76771 4.70803 9.29284 5.00092 8.99994C5.29381 8.70705 5.76869 8.70705 6.06158 8.99994L7.50092 10.4393L11.9403 5.99994Z"
      fill="white"
    />
  </svg>
);
